import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@optools/components/ui/table';
import { LocationOverrideView } from '@optools/services/operator-gateway/types/generated/graphql';
import { formatTimestamp } from '@optools/utils/datetime';

import { StatusBadge } from './status-badge';

export interface ExistingOverridesTableProps {
  email: string;
  overrides: LocationOverrideView[] | undefined;
}

export function ExistingOverridesTable({ email, overrides }: ExistingOverridesTableProps) {
  return (
    <section data-testid="existing-overrides">
      <h2 className="mb-2 text-lg font-bold">Existing Overrides</h2>

      {overrides?.length ? (
        <Table className="whitespace-nowrap">
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Country Code</TableHead>
              <TableHead>IP Address</TableHead>
              <TableHead>Zip Code</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Expiration</TableHead>
              <TableHead>Created At</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {overrides.map((override, index) => {
              const { countryCode, createdAt, expiration, ipAddress, oktaId, zipCode } = override;
              return (
                <TableRow key={oktaId + index}>
                  <TableCell>{oktaId}</TableCell>
                  <TableCell>{email}</TableCell>
                  <TableCell>{countryCode.toUpperCase()}</TableCell>
                  <TableCell>{ipAddress}</TableCell>
                  <TableCell>{zipCode}</TableCell>
                  <TableCell>
                    <StatusBadge expiration={expiration} />
                  </TableCell>
                  <TableCell>{formatTimestamp(expiration)}</TableCell>
                  <TableCell>{formatTimestamp(createdAt)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <p className="text-sm">There are no existing overrides for this user.</p>
      )}
    </section>
  );
}
